const routes = [
  {
    path: '/organisation/questions',
    name: 'OrganisationQuestionsPage',
    auth: true,
    authPage: 'LoginPage',
    loaders: {
      page: () => import('./containers/OrganisationQuestionsPage/OrganisationQuestionsPage'),
    },
  },
];

export default routes;
